import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, map, merge, switchMap } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../../picflow-storyblok';
import { StoryblokRootComponent } from '../components/storyblok-root/storyblok-root.component';

@Component({
  selector: 'app-storyblok-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './storyblok-page.component.html',
  imports: [StoryblokRootComponent, AsyncPipe],
})
export class StoryblokPageComponent {
  private route = inject(ActivatedRoute);
  private storyblokService = inject(PICFLOW_STORYBLOK);

  story$ = merge(this.route.data, this.storyblokService.updates$.pipe(filter(Boolean))).pipe(map(data => data?.story));

  overlayNav$ = this.story$.pipe(map(story => story && story.content.overlayNav));
  prefooter$ = this.story$.pipe(map(story => story && story.content.preFooter?.[0]));

  extraDataMap$ = this.route.data.pipe(
    switchMap(() =>
      this.story$.pipe(
        map(story => {
          const map = new Map<string, { [key: string]: unknown }>();
          map.set('table_of_contents', {
            story,
          });
          map.set('content_group', {
            extraDataMap: map,
          });
          return map;
        })
      )
    )
  );
}
